var $cef7571dc106f48b$exports = {};
$cef7571dc106f48b$exports = {
    "info": `Informationen`,
    "negative": `Fehler`,
    "positive": `Erfolg`
};


export {$cef7571dc106f48b$exports as default};
//# sourceMappingURL=de-DE.mjs.map
